<script setup lang="ts"></script>

<template>
  <faq-list-1-title />
  <faq-list-2-items-important />
  <faq-list-3-items-normal />
</template>
